var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eventcalendar, localeDe, localeEn, localeIt, setOptions, } from '@mobiscroll/react';
import { createRef, useCallback, useMemo, useState } from 'react';
import { useMutation } from "react-query";
import '@mobiscroll/react/dist/css/mobiscroll.scss';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import AvailabilityDialog from "./AvailabilityDialog";
import { addMinutes, diffInMinutes, endOfDay, endOfWeek, startOfDay, startOfWeek } from "../../utils/date.util";
import { AvailabilityService } from "../../services/availability/availability.service";
import AvailabilityChangesDialog from "./AvailabilityChangesDialog";
import { AvailabilityExceptionService } from "../../services/availability/availabilityException.service";
import { useTranslation } from "react-i18next";
import { useTrackScreenVisit } from "../../utils/analytics.util";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ModuleDatePicker from "../ModuleDatePicker";
import { useAvailabilityCalculationResults } from '../../utils/hooks/availability/useResourceAvailability';
import { AvailabilityType } from "../../models/availability/availability.model";
import { useResource } from "../../utils/hooks/resources/useResources";
import { useAllSectors } from "../../utils/hooks/sectors/useSectors";
import { SectorType } from "../../models/sector/sector.model";
import { useServicesForSector } from "../../utils/hooks/services/useServices";
import { useReadOnly } from "../../utils/hooks/users/useReadOnly";
import { getCalendarTimezoneProps, toJsDate, withJsDates } from "../../utils/calendarTimezone";
import { updateSeriesFromOccurrence } from "./availabilitySeriesUpdate";
setOptions({
    theme: 'material',
    themeVariant: 'light'
});
var AvailabilityPlanner = function (props) {
    useTrackScreenVisit('system availability planner');
    var entityId = useParams().entityId;
    var searchParams = useSearchParams()[0];
    var navigate = useNavigate();
    var finalEntityId = props.entityIdFromProps || entityId;
    // Extract date from URL query parameter if provided
    var urlDate = searchParams.get('date');
    var resourceNameUrl = searchParams.get('resourceNameUrl');
    var initialDate = urlDate ? new Date(urlDate) : new Date();
    var _a = useState(startOfWeek(initialDate)), dateRangeFrom = _a[0], setDateRangeFrom = _a[1];
    var _b = useState(endOfWeek(initialDate)), dateRangeTo = _b[0], setDateRangeTo = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), showFullDay = _d[0], setShowFullDay = _d[1];
    var _e = useState(null), hoursMenuAnchorEl = _e[0], setHoursMenuAnchorEl = _e[1];
    var _f = useState(false), changesDialogOpen = _f[0], setChangesDialogOpen = _f[1];
    var _g = useState(), lastChange = _g[0], setLastChange = _g[1];
    var calendarRef = createRef();
    var _h = useTranslation(), t = _h.t, i18n = _h.i18n;
    // Read-only users may view the availability schedule, but not create, move, resize or
    // delete slots (the slot editor in AvailabilityDialog is read-only too).
    var readOnly = useReadOnly();
    var _j = useState([]), myEvents = _j[0], setEvents = _j[1];
    var _k = useState(), currentAvailability = _k[0], setCurrentAvailability = _k[1];
    var _l = useState(false), overlapDialogOpen = _l[0], setOverlapDialogOpen = _l[1];
    var _m = useState(undefined), pendingUpdate = _m[0], setPendingUpdate = _m[1];
    // load only services for weekly planner (the assigned service or resource must have that sector assigned)
    var resource = useResource(finalEntityId);
    var allSectors = useAllSectors();
    var weeklySector = useMemo(function () { return allSectors.find(function (s) { var _a; return (s === null || s === void 0 ? void 0 : s.id) && s.sectorType === SectorType.WEEKLY_PLANNER && ((_a = resource === null || resource === void 0 ? void 0 : resource.sectorIds) === null || _a === void 0 ? void 0 : _a.includes(s.id)); }); }, [allSectors, resource]);
    var weeklyPlannerServices = useServicesForSector(weeklySector === null || weeklySector === void 0 ? void 0 : weeklySector.id);
    var calendarLocale = i18n.language === 'de' ? localeDe :
        i18n.language === 'it' ? localeIt :
            localeEn;
    var availabilitiesCalculationResults = useAvailabilityCalculationResults({
        queryKey: ['availabilities', finalEntityId, dateRangeFrom, dateRangeTo],
        entityIds: [finalEntityId],
        dateRangeFrom: dateRangeFrom,
        dateRangeTo: dateRangeTo,
        setEvents: setEvents
    });
    var refetchAvailabilities = function () {
        availabilitiesCalculationResults.refetch();
    };
    var notifyAvailabilitiesChanged = function () {
        var _a;
        refetchAvailabilities();
        (_a = props.onAvailabilitiesChanged) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    var addAvailabilityMut = useMutation('addAvailability', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AvailabilityService.createAvailability({
                        entityId: finalEntityId,
                        startTime: event.start,
                        endTime: event.end,
                        type: AvailabilityType.OPEN,
                        name: t('Available'),
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
    var updateAvailabilityMut = useMutation('updateAvailability', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var calculationId, availabilityCalc, eventStart, eventEnd, diffStart, diffEnd;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    calculationId = event.id;
                    availabilityCalc = (_a = availabilitiesCalculationResults.data) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.id === calculationId; });
                    if (!availabilityCalc)
                        return [2 /*return*/];
                    eventStart = event.start;
                    eventEnd = event.end;
                    if (event.allDay) {
                        eventStart = startOfDay(eventStart);
                        eventEnd = endOfDay(eventStart);
                    }
                    if (!availabilityCalc.rrule) return [3 /*break*/, 2];
                    // "All events": every day takes the dropped times, the series keeps its own type/name/color
                    // even when the dragged day is an exception, and that day follows the drop
                    return [4 /*yield*/, updateSeriesFromOccurrence({ occurrence: availabilityCalc, newStart: eventStart, newEnd: eventEnd })];
                case 1:
                    // "All events": every day takes the dropped times, the series keeps its own type/name/color
                    // even when the dragged day is an exception, and that day follows the drop
                    _b.sent();
                    notifyAvailabilitiesChanged();
                    return [2 /*return*/];
                case 2:
                    diffStart = diffInMinutes(eventStart, availabilityCalc.occurrenceStartTime);
                    diffEnd = diffInMinutes(eventEnd, availabilityCalc.occurrenceEndTime);
                    return [4 /*yield*/, AvailabilityService.updateAvailability({
                            id: availabilityCalc.availabilityId,
                            entityId: finalEntityId,
                            startTime: addMinutes(availabilityCalc.originalStartTime, diffStart),
                            endTime: addMinutes(availabilityCalc.originalEndTime, diffEnd),
                            rrule: availabilityCalc.rrule,
                            name: availabilityCalc.name,
                            color: availabilityCalc.color,
                            type: availabilityCalc.type,
                            capacityOverride: availabilityCalc.capacityOverride,
                        })];
                case 3:
                    _b.sent();
                    notifyAvailabilitiesChanged();
                    return [2 /*return*/];
            }
        });
    }); });
    var createExceptionMut = useMutation('createAvailabilityException', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var calculationId, availabilityCalc, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    calculationId = event.id;
                    availabilityCalc = (_a = availabilitiesCalculationResults.data) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.id === calculationId; });
                    if (!(availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.exceptionId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, AvailabilityExceptionService.update({
                            id: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.exceptionId,
                            availabilityId: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.availabilityId,
                            originalStartTime: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.occurrenceStartTime,
                            newStartTime: event.start,
                            newEndTime: event.end,
                            name: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.name,
                            color: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.color,
                            capacityOverride: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.capacityOverride,
                            type: availabilityCalc.type,
                        })];
                case 1:
                    response = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, AvailabilityExceptionService.create({
                        availabilityId: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.availabilityId,
                        originalStartTime: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.occurrenceStartTime,
                        newStartTime: event.start,
                        newEndTime: event.end,
                        name: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.name,
                        color: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.color,
                        capacityOverride: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.capacityOverride,
                        type: availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.type,
                    })];
                case 3:
                    response = _b.sent();
                    _b.label = 4;
                case 4:
                    notifyAvailabilitiesChanged();
                    return [2 /*return*/, response];
            }
        });
    }); });
    var myView = useMemo(function () { return ({
        schedule: {
            type: 'week',
            startDay: 1,
            endDay: 0,
            startTime: showFullDay ? '00:00' : '07:00',
            endTime: '23:59',
        },
    }); }, [showFullDay]);
    var handleEventClick = useCallback(function (args) {
        var _a;
        var id = args.event.id;
        var availability = (_a = availabilitiesCalculationResults.data) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.id === id; });
        setCurrentAvailability(availability);
    }, [availabilitiesCalculationResults.data]);
    // state
    var _o = useState(undefined), pendingCreate = _o[0], setPendingCreate = _o[1];
    // helper
    var hasOverlap = function (evt) {
        var start = evt.start;
        var end = evt.end;
        var id = evt.id;
        return myEvents.some(function (e) {
            return e.id !== id &&
                (start < toJsDate(e.end)) &&
                (end > toJsDate(e.start));
        });
    };
    // The calendar renders in the organization's timezone and hands dates back as ISO strings /
    // timezone aware objects - normalise them before they reach the mutations and the overlap check
    var withJsEventDates = function (args) { return (__assign(__assign({}, args), { event: withJsDates(args.event), oldEvent: withJsDates(args.oldEvent) })); };
    var hoursMenuOpen = Boolean(hoursMenuAnchorEl);
    var hoursToggleLabel = showFullDay ? t("Show 07:00 to 24:00") : t("Show 00:00 to 24:00");
    var handleHoursModeSelect = function (fullDay) {
        setShowFullDay(fullDay);
        setHoursMenuAnchorEl(null);
    };
    var handleWeekChange = function (_a) {
        var start = _a.start;
        setDateRangeFrom(startOfWeek(start));
        setDateRangeTo(endOfWeek(start));
    };
    var renderHeader = function () { return (_jsxs(Stack, __assign({ direction: "column", width: "100%", gap: 2 }, { children: [(props.withTitle || resourceNameUrl) &&
                _jsx(Stack, { children: _jsx(Typography, __assign({ variant: "h3" }, { children: resource === null || resource === void 0 ? void 0 : resource.name })) }), _jsxs(Stack, __assign({ direction: "row", justifyContent: "center", alignItems: "center", sx: { pt: 1, pb: 1, position: 'relative' } }, { children: [_jsx(ModuleDatePicker, { variant: "range", value: { start: dateRangeFrom, end: dateRangeTo }, onChange: handleWeekChange, showStepButtons: false, sx: { height: 40 } }), _jsx(IconButton, __assign({ id: "availability-hours-menu-button", "aria-label": hoursToggleLabel, "aria-controls": hoursMenuOpen ? 'availability-hours-menu' : undefined, "aria-haspopup": "true", "aria-expanded": hoursMenuOpen ? 'true' : undefined, size: "small", onClick: function (event) { return setHoursMenuAnchorEl(event.currentTarget); }, sx: {
                            position: 'absolute',
                            top: '50%',
                            right: 0,
                            transform: 'translateY(-50%)',
                            zIndex: 2,
                            width: 32,
                            height: 32,
                            borderRadius: 1,
                        } }, { children: _jsx(SettingsIcon, { fontSize: "small" }) })), _jsxs(Menu, __assign({ id: "availability-hours-menu", anchorEl: hoursMenuAnchorEl, open: hoursMenuOpen, onClose: function () { return setHoursMenuAnchorEl(null); }, anchorOrigin: {
                            vertical: 'center',
                            horizontal: 'left',
                        }, transformOrigin: {
                            vertical: 'center',
                            horizontal: 'right',
                        }, MenuListProps: {
                            'aria-labelledby': 'availability-hours-menu-button',
                        } }, { children: [_jsx(MenuItem, __assign({ selected: !showFullDay, onClick: function () { return handleHoursModeSelect(false); } }, { children: t("Show 07:00 to 24:00") })), _jsx(MenuItem, __assign({ selected: showFullDay, onClick: function () { return handleHoursModeSelect(true); } }, { children: t("Show 00:00 to 24:00") }))] }))] })), _jsx(Divider, {})] }))); };
    return (_jsxs(Box, __assign({ width: "100%" }, { children: [_jsx(Eventcalendar, __assign({ ref: calendarRef, clickToCreate: !readOnly, dragToCreate: !readOnly, dragToMove: !readOnly, dragToResize: !readOnly, eventOverlap: true, eventDelete: !readOnly, data: myEvents, selectedDate: dateRangeFrom, renderHeader: renderHeader, locale: calendarLocale, view: myView }, getCalendarTimezoneProps(), { onEventClick: function (args) {
                    setOpen(true);
                    handleEventClick(args);
                }, onEventCreated: function (args) {
                    if (readOnly)
                        return;
                    var created = withJsDates(args.event);
                    if (hasOverlap(created)) {
                        setPendingCreate(created);
                        setOverlapDialogOpen(true);
                        return;
                    }
                    else {
                        setCurrentAvailability({
                            entityId: finalEntityId,
                            startTime: created.start,
                            endTime: created.end,
                            name: t('New Availability'),
                        });
                        // TODO: this opens the dialog BUT not good code, we should switch to mutateAsync and have a single create function
                        setOpen(true);
                    }
                }, onEventUpdated: function (args) {
                    var _a;
                    if (readOnly)
                        return;
                    var event = withJsEventDates(args);
                    var moved = event.event;
                    if (hasOverlap(moved)) {
                        var prev_1 = event.oldEvent;
                        setEvents(function (list) {
                            return list.map(function (e) { return e.id === moved.id ? __assign(__assign({}, e), { start: prev_1.start, end: prev_1.end, allDay: prev_1.allDay }) : e; });
                        });
                        setPendingUpdate(event);
                        setOverlapDialogOpen(true);
                        return;
                    }
                    else {
                        var calculationId_1 = moved.id;
                        var availabilityCalc = (_a = availabilitiesCalculationResults.data) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.id === calculationId_1; });
                        if (availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.rrule) {
                            setChangesDialogOpen(true);
                            setLastChange(event);
                        }
                        else {
                            updateAvailabilityMut.mutate(moved);
                        }
                    }
                }, 
                // Date picker already sets date range, no need for this one
                // (and it anyway sets day +1 which causes fast double fetch)
                // onPageChange={(event) => {
                //     setDateRangeFrom(event.firstDay);
                //     setDateRangeTo(event.lastDay);
                // }}
                firstDay: 1 })), _jsx(AvailabilityDialog, { open: !!currentAvailability, availability: currentAvailability, setCurrentAvailability: setCurrentAvailability, entityId: finalEntityId, onClose: function () {
                    setOpen(false);
                    setCurrentAvailability(undefined);
                    refetchAvailabilities();
                }, onConfirm: function () {
                    setCurrentAvailability(undefined);
                    setOpen(false);
                    notifyAvailabilitiesChanged();
                }, onDeleted: function () {
                    setCurrentAvailability(undefined);
                    notifyAvailabilitiesChanged();
                    setOpen(false);
                }, resource: resource, weeklyPlannerServices: weeklyPlannerServices, weeklySector: weeklySector }), _jsx(AvailabilityChangesDialog, { open: !!lastChange, onClose: function () {
                    var _a;
                    setLastChange(undefined);
                    (_a = calendarRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
                    refetchAvailabilities();
                }, onPick: function (option) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(option === 'all')) return [3 /*break*/, 2];
                                return [4 /*yield*/, updateAvailabilityMut.mutate(lastChange === null || lastChange === void 0 ? void 0 : lastChange.event)];
                            case 1:
                                _a.sent();
                                setLastChange(undefined);
                                return [3 /*break*/, 4];
                            case 2:
                                if (!(option === 'current')) return [3 /*break*/, 4];
                                return [4 /*yield*/, createExceptionMut.mutate(lastChange === null || lastChange === void 0 ? void 0 : lastChange.event)];
                            case 3:
                                _a.sent();
                                setLastChange(undefined);
                                _a.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, changeOptions: ['current', 'all'] }), _jsxs(Dialog, __assign({ open: overlapDialogOpen, onClose: function () {
                    var _a;
                    if (pendingCreate)
                        (_a = calendarRef.current) === null || _a === void 0 ? void 0 : _a.removeEvent(pendingCreate);
                    setOverlapDialogOpen(false);
                    setPendingUpdate(undefined);
                    setPendingCreate(undefined);
                }, maxWidth: "sm", fullWidth: true }, { children: [_jsx(DialogTitle, { children: t('Overlap detected') }), _jsx(DialogContent, { children: t('This change overlaps another event. Do you want to continue?') }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () {
                                    var _a;
                                    if (pendingCreate)
                                        (_a = calendarRef.current) === null || _a === void 0 ? void 0 : _a.removeEvent(pendingCreate);
                                    setOverlapDialogOpen(false);
                                    setPendingUpdate(undefined);
                                    setPendingCreate(undefined);
                                } }, { children: t('Cancel') })), _jsx(Button, __assign({ variant: "contained", color: "error", onClick: function () {
                                    var _a;
                                    if (pendingCreate) {
                                        setCurrentAvailability({
                                            entityId: finalEntityId,
                                            startTime: pendingCreate.start,
                                            endTime: pendingCreate.end,
                                            name: t('New Availability'),
                                        });
                                        // calendarRef.current?.removeEvent(pendingCreate)
                                        // addAvailabilityMut.mutate(pendingCreate)
                                        setPendingCreate(undefined);
                                        setOverlapDialogOpen(false);
                                        return;
                                    }
                                    if (pendingUpdate) {
                                        var moved_1 = pendingUpdate.event;
                                        setEvents(function (list) {
                                            return list.map(function (e) { return e.id === moved_1.id ? __assign(__assign({}, e), { start: moved_1.start, end: moved_1.end, allDay: moved_1.allDay }) : e; });
                                        });
                                        var calculationId_2 = moved_1.id;
                                        var availabilityCalc = (_a = availabilitiesCalculationResults.data) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.id === calculationId_2; });
                                        if (availabilityCalc === null || availabilityCalc === void 0 ? void 0 : availabilityCalc.rrule) {
                                            setChangesDialogOpen(true);
                                            setLastChange(pendingUpdate);
                                        }
                                        else {
                                            updateAvailabilityMut.mutate(moved_1);
                                        }
                                        setPendingUpdate(undefined);
                                        setOverlapDialogOpen(false);
                                    }
                                } }, { children: t('Confirm') }))] })] }))] })));
};
export default AvailabilityPlanner;
